import axios from './axios';

export const createCourse = (body) =>
  axios.post('/admin/courses', body)
    .then(({ data }) => data);

export const updateCourse = (id, body) =>
  axios.put(`/admin/courses/${id}`,body)
    .then(({ data }) => data);

export const deleteCourse = (id) =>
  axios.delete(`/admin/courses/${id}`)
    .then(({ data }) => data);

export const createCategory = (body) =>
  axios.post('/admin/courses/create_category', body)
    .then(({ data }) => data);

export const updateCategory = (id, body) =>
  axios.put(`/admin/courses/categories/${id}`, body)
    .then(({ data }) => data);

export const deleteCategory = (id) =>
  axios.delete(`/admin/courses/categories/${id}`)
    .then(({ data }) => data);
